export default {
	translation: {
		general: {
			'whats-up': `有什么新鲜事？`,
			date: '日期',
			location: '位置',
			remove: '删除',
			all: '全部',
			sum: '总和',
			avg: '平均数',
			min: '最小值',
			max: '最大值',
			save: '保存',
			cancel: '取消',
			show: '显示',
			done: '完成',
			hide: '隐藏',
			customize: '自定义',
			start: '开始',
			end: '结束',
			set: '设定',
			edit: '编辑',
			created: '创建',
			local: '本地',
			finished: '已完成',
			cloud: '云端',
			search: '搜索',
			'delete-from-nomie': `从 Nomie 删除 {{thing}}？`,
			'learn-more': '了解详情',
			'open-source': '开源',
			version: '版本',
			questions: '问题？',
			faq: '常见问题',
			'continue-question': '确认继续？',
			loading: '加载中...',
		},
		tabs: {
			track: '记录',
			history: '历史',
			settings: '设置',
			plugins: '插件',
		},
		history: {
			'no-records-found': '没有找到任何记录',
		},
		export: {
			csv: {
				download: '下载 CSV...',
				description:
					'Export your individual tracker data to CSV. Only one year at a time is supported. Please note, that CSV exports cannot currently be imported back into Nomie. ',
			},
			backup: {
				description: `Create an importable backup file. This allows you to transfer your data from one device to another using a single JSON file that contains ALL of you Nomie data.`,
				download: '下载备份文件...',
			},
		},
		board: {
			'board-empty': '这里什么都没有！',
			'edit-board': `编辑标签页`,
			'board-label': '标签页名称',
			'create-custom-tracker': '新建记录器',
			'add-existing-tracker': '添加现有记录器',
			'browse-starter-trackers': '浏览记录器库',
			'add-a-board': '新建标签页',
			'add-a-board-description': `Tabs help you organize your trackers. For example: social, food, and fitness can contain trackers specifically for those activies. You can have the same tracker on multiple tabs.`,
			'board-input-placeholder': '标签页名称或 Emoji 👍',
		},
		settings: {
			'sign-out': '登出',
			'enable-boards': '记录器标签页',
			settings: '设置',
			'use-location': '使用位置信息',
			'dark-mode': '深色模式',
			'require-pin': '使用密码',
			'24-hour-clock': '24 小时制',
			data: '日期',
			'nomie-api': 'Nomie API',
			'import-from-backup': '导入备份',
			'generate-backup': '导出备份',
			'generate-csv': '导出为 CSV',
			'find-and-replace': '查找和替换',
			storage: '储存',
			'use-local': '切换到本地',
			'use-cloud': '切换到云端',
			'first-book': '第一份记录',
			'about-nomie': '关于 Nomie',
			'export-confirm': `This process might take a couple minutes. 
            If you have a lot of data, it will seem like it gets hung up. 
            Have patience.`,
			'export-complete': '导出完成！',
			'switch-to-cloud-notice': `Data is not automatically migrated to the cloud.
            You should export your local data first, then import it once the switch is complete. 
            You can always switch back`,
			'switch-to-cloud-confirm': '切换到 Blockstack 储存？',
			'switch-to-local-notice': `Data is not automatically migrated FROM the cloud.
            You should export your data first, then import it once the switch is complete. 
            You can always switch back`,
			'switch-to-local-confirm': '切换到本地储存？',
			'pin-details': '请输入 1 到 6 位的数字',
			'aggressive-sync': '强制同步',
			'aggressive-description': `在多个设备上同时使用 Nomie 时，打开强制同步来增加同步频率`,
		},
		tracker: {
			'things-to-track': '需要记录的事情',
			'install-tracker-question': '安装 {{tracker}}？',
			'add-tracker': '添加记录器',
			'edit-tracker': '编辑记录器',
			label: '名称',
			emoji: 'Emoji',
			tag: '标签',
			type: '种类',
			'save-on-tap': '点击即保存',
			'measure-by': '统计单位',
			calculate: '计算',
			count: '个数',
			default: '默认',
			positivity: '积极性',
			'min-max': '最小值/最大值',
			'note-placeholder': '#any #tracker #hashtags',
			'note-description': `Combine multiple trackers together using their
            #hashtags. For example, #mood #sleep_quality. Nomie will then ask
            for values one by one.`,
			'delete-description': `You can always recreate it later. No historic data will be deleted deleted.`,
		},
	},
};
